import { atom } from 'recoil';

import { CollectionSurvey } from '@src/generated/hooks';

export type SurveyAtom = {
  answers: Record<string, any>;
  error?: string;
  survey: CollectionSurvey;
};

/**
 * @name surveyAtom
 * @description This atom holds a survey and the relevant answers. We're
 * making the assumption that we'll only ever have one survey on the screen
 * for a user at a time (FYI).
 */
export const surveyAtom = atom<SurveyAtom>({
  default: {
    answers: {}, // Initialized with local storage data when present
    error: undefined, // If we have an error string render it
    survey: {
      created: new Date().toISOString(),
      id: '',
      modified: new Date().toISOString(),
      name: '',
      questions: [],
      success: '',
      tracking: {},
      version: 0
    }
  },
  key: 'surveyAtom'
});
